export default "https://assets.pclncdn.com/web/next-landing/aa244f7d83/_next/static/images/san-francisco-7de36c9d7d49993d020c0628c880b256.jpg";